import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import cardOperationSearch from './views/card-operation-search'
import grantOfCoupon from './views/components/grant-of-coupon'

export default [
  {
    path: RoutePathConstants.CARD_OPERATION_SEARCH,
    name: 'cardOperationSearch',
    component: cardOperationSearch
  },
  {
    path: RoutePathConstants.GRANT_OF_COUPON,
    name: 'grantOfCoupon',
    component: grantOfCoupon
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/routers.js